import { render, staticRenderFns } from "./Gszc.vue?vue&type=template&id=32a56bfc&scoped=true&"
import script from "./Gszc.vue?vue&type=script&lang=js&"
export * from "./Gszc.vue?vue&type=script&lang=js&"
import style0 from "./Gszc.vue?vue&type=style&index=0&id=32a56bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a56bfc",
  null
  
)

export default component.exports